import React, { Component } from 'react';
// import ReactDOM from "react-dom";
import { connect } from 'react-redux';
import { Table, Column, Cell } from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css';
// import * as Contracts from '../../Store/Contracts';
import * as OfficeContracts from './Saga/OfficeContracts';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import WebIcon from '@material-ui/icons/Web';
import StorageIcon from '@material-ui/icons/Storage';
import Backup from '@material-ui/icons/Backup';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import SubjectIcon from '@material-ui/icons/Subject';
import { Modal, Row, Col, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import './Css/Grid.css';
// import '../../Css/Grid.css';
import moment from 'moment'
import { IconButton } from '@material-ui/core';

interface Props {
  rent_contracts_list: any,
  update_rent_contracts: any,
  user_details: any;
}



interface State {
  modal: boolean;
  modal_contacts: boolean;
  modal_replace: boolean;
  change: boolean;
  search: any;
  columnWidths: any;
  modal_tinkaku: boolean;
  modal_contract_id: any;
  modal_workflow_id: any;
  refresh: boolean;

}


const defaultColumnProperties = {
  sortable: true,
  // width: 120
};






class OfficeContractsGrid extends Component<Props, State> {
  constructor(props: Readonly<Props>) {
    super(props);

    this.state = {
      modal: false,
      modal_contacts: false,
      modal_replace: false,
      // modalselect: false,
      change: false,
      search: '',
      modal_tinkaku: false,
      modal_contract_id: '',
      modal_workflow_id: '',
      refresh: false,

      columnWidths: {
        application_date: 100,
        contract_date: 100,
        credit_entry_at: 130,
        contractor_name1: 230,
        contractor_kana1: 180,
        building_name: 190,
        room_name: 80,
        contract_money: 120,
        bk_no: 80,
        cloudsign_completed_at: 100,
        payment_date: 100,
        payment_type: 80,
        apply_payment_type: 80,
        month_payment_type: 80,
        cancel_date: 100,
      }
    };

    this._onColumnResizeEndCallback = this._onColumnResizeEndCallback.bind(this);
    this._rowClassNameGetter = this._rowClassNameGetter.bind(this);
  }

  _onColumnResizeEndCallback(newColumnWidth: any, columnKey: any) {
    this.setState(({ columnWidths }) => ({
      columnWidths: {
        ...columnWidths,
        [columnKey]: newColumnWidth,
      },
    }));
  }

  _rowClassNameGetter(index: any) {
    if (this.props.rent_contracts_list && this.props.rent_contracts_list[index]) {
      // alert(this.props.rent_contracts_list[index].bk_no > 0 && (this.props.rent_contracts_list[index].ver != this.props.rent_contracts_list[index].log_confirm) ? "edit" : this.props.rent_contracts_list[index].cancel_date && this.props.rent_contracts_list[index].bk_no > 0 ? "cancel_zumi" : this.props.rent_contracts_list[index].cancel_date ? "cancel_mi" : this.props.rent_contracts_list[index].cloudsign_completed_at && (this.props.rent_contracts_list[index].payment_type == 2 || this.props.rent_contracts_list[index].apply_payment_type == 1) ? "completed" : "")
      return this.props.rent_contracts_list[index].cancel_date && this.props.rent_contracts_list[index].bk_no > 0 ? "cancel_zumi" : this.props.rent_contracts_list[index].cancel_date ? "cancel_mi" : this.props.rent_contracts_list[index].bk_no > 0 && (this.props.rent_contracts_list[index].ver != this.props.rent_contracts_list[index].log_confirm) ? "edit" : this.props.rent_contracts_list[index].cloudsign_completed_at && (this.props.rent_contracts_list[index].payment_type == 2 || this.props.rent_contracts_list[index].apply_payment_type == 1) ? "completed" : "new"
    } else {
      return ""
    }
  }

  openRentResponses(id: any) {
    // window.open("https://crm.homestation.jp/customer/" + id, '_blank', 'noopener')
    window.open("https://crm.homestation.jp/contracts/" + id, '_blank', 'noopener')

  }
  openRentContracts(contract_id: any, workflow_id: any) {
    // alert(contract_id)
    // alert(workflow_id)
    window.open("http://192.168.0.207/fuelphp-1.8/public/contraction/link/new?rent_contract_id=" + contract_id + "&login_user_id=" + this.props.user_details.id, '_blank', 'noopener')
    this.props.update_rent_contracts(workflow_id)

    this.setState({
      refresh: !this.state.refresh,
      modal_tinkaku: false,
      modal_contract_id: '',
      modal_workflow_id: ''
    })

  }


  openSheet(id: any) {
    // alert(id)
    window.open("https://www.homestation.jp/manage/rent/sheet/followsheet/pdfazurep?keiri=1&c_id=" + id, '_blank', 'noopener')
  }


  render() {

    return (
      <div style={{ width: "100%" }}>

        <Chip style={{ float: "right" }} label={this.props.rent_contracts_list ? this.props.rent_contracts_list.length + "件" : ""} variant="outlined" ></Chip>

        <div style={{ float: "right", marginTop: 4 }}>
          <div style={{ backgroundColor: "rgb(167, 167, 167)", float: "left", fontSize: "11px", marginRight: 5, padding: 3, borderRadius: 3 }}>キャンセル(未登録)</div>
          <div style={{ backgroundColor: "red", float: "left", fontSize: "11px", marginRight: 5, padding: 3, borderRadius: 3 }}>キャンセル(登録済)</div>
          <div style={{ backgroundColor: "#1e90ff", float: "left", fontSize: "11px", marginRight: 5, padding: 3, borderRadius: 3 }}>契約締結済</div>
          <div style={{ backgroundColor: "rgb(252, 252, 252)", float: "left", fontSize: "11px", marginRight: 5, padding: 3, borderRadius: 3, border: "1px solid #c5c5c5" }}>契約締結待ち</div>
          <div style={{ backgroundColor: "rgb(255, 202, 87)", float: "left", fontSize: "11px", marginRight: 5, padding: 3, borderRadius: 3 }}>変更あり</div>

        </div>

        <div style={{ clear: "both" }}></div>
        {this.props.rent_contracts_list ? <Table
          rowHeight={42}
          rowsCount={this.props.rent_contracts_list.length}
          width={window.innerWidth - 300}
          height={window.innerHeight - 110}
          headerHeight={34}
          onColumnResizeEndCallback={this._onColumnResizeEndCallback}
          isColumnResizing={false}
          className="gridOfficeContracts"
          rowClassNameGetter={this._rowClassNameGetter}

        >
          <Column width={50} header={<Cell>詳細</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}><IconButton style={{ marginTop: -10 }} onClick={() => this.openRentResponses(this.props.rent_contracts_list[rowIndex].id)} size="small" ><AccountBoxIcon style={{ color: "#4f5357" }} /></IconButton></Cell>)} />
          <Column width={50} header={<Cell>シート</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}><IconButton style={{ marginTop: -10 }} onClick={() => this.openSheet(this.props.rent_contracts_list[rowIndex].id)} size="small" ><SubjectIcon style={{ color: "#4f5357" }} /></IconButton></Cell>)} />
          <Column width={50} header={<Cell>賃革</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}><IconButton style={{ marginTop: -10 }} onClick={(e) => { this.setState({ "modal_tinkaku": true, "modal_contract_id": this.props.rent_contracts_list[rowIndex].id, "modal_workflow_id": this.props.rent_contracts_list[rowIndex].workflow_id }) }} size="small"><Backup style={{ color: "#4f5357" }} /></IconButton></Cell>)} />

          <Column width={this.state.columnWidths.bk_no} isResizable={true} columnKey={"bk_no"} header={<Cell>賃貸革命</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}>{this.props.rent_contracts_list[rowIndex].bk_no > 0 ? "登録済" : "未"}</Cell>)} />
          <Column width={this.state.columnWidths.application_date} isResizable={true} columnKey={"application_date"} header={<Cell>申込日</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}>{moment(this.props.rent_contracts_list[rowIndex].application_date).format("YYYY-MM-DD")}</Cell>)} />
          <Column width={this.state.columnWidths.contract_date} isResizable={true} columnKey={"contract_date"} header={<Cell>契約日</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}>{moment(this.props.rent_contracts_list[rowIndex].contract_date).format("YYYY-MM-DD")}</Cell>)} />
          {/* {this.props.rent_contracts_list[rowIndex].workflow_id}-{this.props.rent_contracts_list[rowIndex].log_confirm}-{this.props.rent_contracts_list[rowIndex].ver} */}
          <Column width={this.state.columnWidths.contractor_name1} isResizable={true} columnKey={"contractor_name1"} header={<Cell>契約者</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}><div style={{ fontSize: 10, whiteSpace: "nowrap" }}>{this.props.rent_contracts_list[rowIndex].contractor_kana1}</div><div>{this.props.rent_contracts_list[rowIndex].contractor_name1}</div></Cell>)} />
          {/* <Column width={this.state.columnWidths.contractor_kana1} isResizable={true} columnKey={"contractor_kana1"} header={<Cell>契約者</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{borderTop: "1px solid  #9c9c9c"}} {...props}>{this.props.rent_contracts_list[rowIndex].contractor_kana1}</Cell>)} /> */}
          <Column width={this.state.columnWidths.building_name} isResizable={true} columnKey={"building_name"} header={<Cell>物件名</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}>{this.props.rent_contracts_list[rowIndex].building_name}</Cell>)} />
          <Column width={this.state.columnWidths.room_name} isResizable={true} columnKey={"room_name"} header={<Cell>号</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}>{this.props.rent_contracts_list[rowIndex].room_name}</Cell>)} />
          <Column width={this.state.columnWidths.cloudsign_completed_at} isResizable={true} columnKey={"cloudsign_completed_at"} header={<Cell>契約締結日</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}>{this.props.rent_contracts_list[rowIndex].cloudsign_completed_at ? moment(this.props.rent_contracts_list[rowIndex].cloudsign_completed_at).format("YYYY-MM-DD") : ""}</Cell>)} />
          <Column width={this.state.columnWidths.payment_date} isResizable={true} columnKey={"payment_date"} header={<Cell>支払日</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}>{this.props.rent_contracts_list[rowIndex].payment_date ? moment(this.props.rent_contracts_list[rowIndex].payment_date).format("YYYY-MM-DD") : ""}</Cell>)} />
          <Column width={this.state.columnWidths.payment_type} isResizable={true} columnKey={"payment_type"} header={<Cell>支払区分</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}>{this.props.rent_contracts_list[rowIndex].payment_type == 1 ? "振込" : this.props.rent_contracts_list[rowIndex].payment_type == 2 ? "カード" : this.props.rent_contracts_list[rowIndex].payment_type == 3 ? "口座振替" : ""}</Cell>)} />
          <Column width={this.state.columnWidths.apply_payment_type} isResizable={true} columnKey={"apply_payment_type"} header={<Cell>支払予定区分</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}>{this.props.rent_contracts_list[rowIndex].apply_payment_type == 1 ? "振込" : this.props.rent_contracts_list[rowIndex].apply_payment_type == 2 ? "カード" : this.props.rent_contracts_list[rowIndex].apply_payment_type == 3 ? "口座振替" : ""}</Cell>)} />
          <Column width={this.state.columnWidths.month_payment_type} isResizable={true} columnKey={"month_payment_type"} header={<Cell>月々支払区分</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}>{this.props.rent_contracts_list[rowIndex].month_payment_type == 1 ? "振込" : this.props.rent_contracts_list[rowIndex].month_payment_type == 2 ? "カード" : this.props.rent_contracts_list[rowIndex].month_payment_type == 3 ? "口座振替" : ""}</Cell>)} />
          <Column width={this.state.columnWidths.credit_entry_at} isResizable={true} columnKey={"credit_entry_at"} header={<Cell>クレジット登録日</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}>{this.props.rent_contracts_list[rowIndex].credit_entry_at ? moment(this.props.rent_contracts_list[rowIndex].credit_entry_at).format("YYYY-MM-DD") : ""}</Cell>)} />
          <Column width={this.state.columnWidths.contract_money} isResizable={true} columnKey={"contract_money"} header={<Cell>契約金</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}>¥{this.props.rent_contracts_list[rowIndex].contract_money.toLocaleString()}</Cell>)} />
          <Column width={this.state.columnWidths.cancel_date} isResizable={true} columnKey={"cancel_date"} header={<Cell>キャンセル日</Cell>} cell={({ rowIndex, ...props }) => (<Cell style={{ borderTop: "1px solid  #9c9c9c" }} {...props}>{this.props.rent_contracts_list[rowIndex].cancel_date ? moment(this.props.rent_contracts_list[rowIndex].cancel_date).format("YYYY-MM-DD") : ""}</Cell>)} />

        </Table> : ""}


        <Modal isOpen={this.state.modal_tinkaku} fade={false} className="modal-dialog-centered">
          <ModalBody>
            <div>賃貸革命へデータを登録します。よろしいですか？</div>
          </ModalBody>
          <ModalFooter>
            <Button variant="contained" color="primary" onClick={() => this.openRentContracts(this.state.modal_contract_id, this.state.modal_workflow_id)}>登録</Button>
            <Button variant="contained" style={{ marginLeft: 3 }} onClick={(e) => { this.setState({ "modal_tinkaku": false, "modal_contract_id": '', "modal_workflow_id": '' }) }}>閉じる</Button>
          </ModalFooter>

        </Modal>
      </div>
    );
  }


}



const mapStateToProps = (state: any) => {
  return {
    rent_contracts_list: state.OfficeContracts.rent_contracts_list,
    user_details: state.masterReducer.user_details,
  }
}
function mapDispatchToProps(dispatch: any) {
  return {
    // bind_kyousai_contract(state: any) {
    //   dispatch(OfficeContracts.bind_kyousai_contract(state))
    // },
    // change_bind_disabled(state: any) {
    //   dispatch(OfficeContracts.change_bind_disabled(state))
    // },

    update_rent_contracts(state: any) {
      dispatch(OfficeContracts.update_rent_contracts(state))
    },



  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OfficeContractsGrid);